import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
  })
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor(
    private spinner: NgxSpinnerService,) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.totalRequests++;
    this.spinner.show('formLoader')
    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
            this.spinner.hide('formLoader')
        }
      })
    );
  }
}
